import { isSalesRep, readToken, readUser } from "services/localStorage.service";

export const getEmailConfiguration = (
  profileData: any,
  search_id: any,
  roleData: any,
  templateData: any = null,
  externalCompany: any = null,
  profileId: number
) => {
  const userInfo = readUser();

  const recruiter: any = {
    fullName: `${userInfo.first_name} ${userInfo.last_name}`,
  };
  if (!externalCompany) {
    externalCompany = "";
  }
  if (!templateData || !templateData.emailSignature) {
    recruiter["emailSignature"] = userInfo.email_signature
      ? userInfo.email_signature
      : `${userInfo.first_name} ${userInfo.last_name}`;
  }
  const tokenDetails = {
    token: readToken(),
    profileId: profileId,
  };

  let template = {};

  if (templateData) {
    template = {
      subject: templateData.subject,
      text: templateData.content,
      emailSignature: templateData.signature,
      otherInstructions: templateData.otherInstructions ? templateData.otherInstructions : [],
    };
  }

  if (isSalesRep()) {
    const salesMeta = {
      user: userInfo.email,
      accountType: "sales_rep",
    };

    const salesDetails = {
      product: roleData ? roleData.product : "",
      whyTheProductStandsOut: [roleData ? roleData.description : ""],
    };

    const otherData: any = {};
    if (roleData && roleData.other_details) {
      otherData["other_details"] = roleData.other_details;
    }
    return {
      ...tokenDetails,
      ...otherData,
      formatResult: true,
      config: {
        meta: salesMeta,
        salesDetails: salesDetails,
        hiringDetails: {
          recruiter: recruiter,
        },
      },
      template: template,
      externalCompany: externalCompany,
    };
  } else {
    const hiringDetails = {
      hiringCompany: roleData ? roleData.recruiting_company : "",
      positionTitle: roleData ? roleData.title : "",
      recruiter: recruiter,
    };
    return {
      ...tokenDetails,
      formatResult: true,
      config: {
        hiringDetails: hiringDetails,
      },
      template: template,
      externalCompany: externalCompany,
    };
  }
};
